import axios from "axios";

const VERSION = process.env.REACT_APP_API_VERSION || "v1";
const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/${VERSION}`,
});

// ****** enable the following code to attach authorization headers on each request and for logging out when an unauthorize request is send *****//

axiosInstance.interceptors.request.use(async function (config) {
  const token = localStorage.getItem("token");
  const restaurantId = localStorage.getItem("restaurantId");
  const requestConfig = config;  
  if (token && token !== "undefined" && token !== "null") {
    requestConfig.headers.Authorization = `JWT ${JSON.parse(token)}`;
    
  }
  requestConfig.headers["X-RESTAURANT-ID"] = restaurantId || '1';
  return config;
});
axiosInstance.interceptors.response.use(
  function (response) {      
    return response;
  },
  async function (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      return window.location.href = '/' ;
      // Show toast message login to continue
    } else {
      // something went wrong
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
